import { Ref } from 'vue';

export function useObserver(elem: Ref<HTMLElement | null>, callback: () => void) {
  if (!elem.value) return;
  const observer = new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting) {
      callback();
    }
  });
  if (elem.value) {
    observer.observe(elem.value);
  }
}
